import { httpClient } from 'angieslist-app-platform';

export type GetCategoryGroupResponse = {
  categoryGroupId: number;
  name: string;
}

const categoryGroupService = {
  getCategoryGroup: categoryId => httpClient.get(`/gateway/advertising/v1/category/${categoryId}/categoryGroup`),
};

export default categoryGroupService;



// WEBPACK FOOTER //
// ./src/app/common/category-group/categoryGroupService.js